export default {
  content: undefined,
  initial_content: undefined,
  theme_id: undefined,
  template_id: undefined,

  sales_unit_id: undefined,
  product_id: undefined,
  department_id: undefined,

  fetchedPoster: undefined,

  promotion_product_id: undefined,
  promotion_unit2_id: undefined,
  payment_types: [],
  proportional_measures: [
    'Quilograma',
    'Litro',
    'Centímetro',
  ],
  selected_type: undefined,
  insertExpirationDates: false,
  insertProportionalValueInline: false,
  insertProductProportionalValueInline: false,
  insertProductExpirationDates: false,
  insertProductOlder: false,
  update_price: true,

  fields: {
    brand: undefined,
    retail_packaging: undefined,
    wholesale_packing: undefined,
    big_packing: undefined,
    validation: undefined,
    retail_taxation: undefined,
    wholesale_taxation: undefined,
    big_taxation: undefined,
    light_taxation: undefined,
    retail_media: undefined,
    wholesale_media: undefined,
    big_media: undefined,
    light_media: undefined,
    big_price: undefined,
    light_price: undefined,
    light_quantity: undefined,
    cet_py: undefined,
    cet: undefined,
    departament: undefined,
    with_down_payment: false,
    payment_type_id: undefined,
    discount: undefined,
    discount_bundle: undefined,
    has_interest: undefined,
    legal_informations: undefined,
    main_description: undefined,
    main_description2: undefined,
    main_description3: undefined,
    minor_description: undefined,
    minor_description2: undefined,
    minor_description3: undefined,
    simple_description: undefined,
    simple_description2: undefined,
    simple_description3: undefined,
    simple_description4: undefined,
    simple_description5: undefined,
    reoperated_product: undefined,
    product_older: undefined,
    product_other_sizes: undefined,
    product_other_colors: undefined,
    product_comments: undefined,
    product_evaluation: undefined,
    product_material: undefined,
    product_depth: undefined,
    product_height: undefined,
    product_width: undefined,
    free_text: undefined,
    free_text2: undefined,
    free_text3: undefined,
    parcel_paid: undefined,
    parceled_interest: undefined,
    parceled_interest_2: undefined,
    parcel: undefined,
    exclusive_parcel: undefined,
    parceled: undefined,
    parcel_separated_2: undefined,
    payment_type: undefined,
    condition: undefined,
    product_code: undefined,
    integration_code: undefined,
    promotion_description: undefined,
    promotion_main_description: undefined,
    promotion_minor_description: undefined,
    promotion_product: undefined,
    promotion_unit: undefined,
    promotion_unit2: undefined,
    promotional_product_value: undefined,
    quantity: undefined,
    quantity2: undefined,
    quantity3: undefined,
    rates_info: undefined,
    sales_unit_wholesale: undefined,
    sales_unit: undefined,
    sales_unit2: undefined,
    sales_unit3: undefined,
    spare: undefined,
    spared_percent: undefined,
    total_term: undefined,
    total_term_2: undefined,
    valid_from: undefined,
    valid_until: undefined,
    validate: undefined,
    free_value: undefined,
    value_cash: undefined,
    value_cash2: undefined,
    value_cash3: undefined,
    value_bundle: undefined,
    old_price: undefined,
    value_divided: undefined,
    reduced_value: undefined,
    value_old: undefined,
    value_old2: undefined,
    value_old3: undefined,
    value_plot_interest: undefined,
    value_plot_interest_2: undefined,
    value_plot: undefined,
    value_plot_separated: undefined,
    value_plot_separated_2: undefined,
    exclusive_value_plot: undefined,
    value_remaining: undefined,
    value_retail: undefined,
    value_sum: undefined,
    value_total_wholesale: undefined,
    value_wholesale: undefined,
    unitary_value: undefined,
    cashback_value: undefined,
    cashback_value_2: undefined,
    value_in_cash: undefined,
    exclusive_value_in_cash: undefined,
    exclusive_value_cash: undefined,
    total_value: undefined,
    custom_qr_code: undefined,
    qr_code: undefined,
    insert_qrcode: false,
    insert_custom_qrcode: false,
    bar_code: undefined,
    insert_barcode: false,
    image: undefined,
    inputs: undefined,
    value_wholeretail: undefined,
    value_wholeretail_2: undefined,
    value_wholeretail_3: undefined,
    value_wholeretail_4: undefined,
    value_wholeretail_5: undefined,
    proportional_value: undefined,
    quantity4: undefined,
    quantity5: undefined,
    unit_proportional: undefined,
    has_without_payment_initial: false,
    from_wholesale: undefined,
    from_large: undefined,
    exclusive_parcel_2: undefined,
    exclusive_value_in_cash_2: undefined,
    exclusive_value_cash_2: undefined,
    exclusive_value_plot_2: undefined,
    ibm_code: undefined,
    product_weight: undefined,
    highlight_1: undefined,
    highlight_2: undefined,
    highlight_3: undefined,
    highlight_4: undefined,
    highlight_5: undefined,
    highlight_6: undefined,
    value_wholesale_card: undefined,
    value_cash_tag: undefined,
    insert_value_cash_tag: false,
    proportional_measure: undefined,
    proportional_quantity: undefined,
    product_proportional_value: undefined,
    quantity_fractional: undefined,
    base_value: undefined,
    base_total_value: undefined,
    base_parcel_quantity: undefined,
    base_parcel_value: undefined,
    derived_code: undefined,
    warranty: undefined,
    assembly: undefined,
    about_product: undefined,
    supported_weight: undefined,
    discount_fastshop: undefined,
    offer_information: undefined,
    insert_offer_information: false,
    optional_free_text: undefined,
    insert_optional_free_text: false,
    percentage_app: undefined,
    price_app: undefined,
    limit_app: undefined,
    percentage_card: undefined,
    price_card: undefined,
    limit_card: undefined,
    parcel_number_card: undefined,
    parcel_price_card: undefined,
    minimum_app: undefined,
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/poster/state.js